import jwtService from "../api/jwt.service";

const user = JSON.parse(jwtService.getItem("user"));

export const initialState = {
  isAuthenticated: jwtService.getItem("token") ? true : false,
  user: user || null,
  isEmailVerified: jwtService.getItem("token") ? true : false,
  hasProfile: user ? user.hasProfile : false,
  isLowBandwidth: JSON.parse(jwtService.getItem("isLowBandwidth")) || false,
};

export function authReducer(state, action) {
  switch (action.type) {
    case "AUTH": {
      return { ...state, isAuthenticated: true, isEmailVerified: true };
    }
    case "LOAD_USER": {
      return { ...state, user: action.user };
    }
    case "LOGOUT": {
      return { ...state, isAuthenticated: false, user: null };
    }

    case "SET_HAS_PROFILE": {
      return { ...state, hasProfile: true };
    }

    case "SET_BANDWIDTH": {
      return { ...state, isLowBandwidth: !state.isLowBandwidth };
    }

    default:
      return state;
  }
}
